import { FC } from "react";

import { TimeSpan } from "@app/shared/lib/TimeSpan";
import { Duration } from "@app/shared/ui/Duration";

import styles from "./VoiceRecordDuration.module.scss";

type Props = {
  duration: TimeSpan;
};

export const VoiceRecordDuration: FC<Props> = ({ duration }) => {
  return (
    <div className="flex align-center gap-5">
      <div className={styles.record_dot} />
      <Duration duration={duration} />
    </div>
  );
};
